export const myShopList = [
  {
    id: 2,
    name: "智联同城",
    rzTime: "2019-11-12",
    dqTime: "2019-12-23",
    status: 1,
    xyScore: 90,
    xyGrade: "良",
    bzMoney: 0,
    shopType: "家电",
    rate: 0.9,
    joinType: "来自青云同城的推荐/自入",
    shopGrade: "黄金商户",
    zye: 1090,
    kyye: 1090,
    zjye: 0,
    lxr: "派大星",
    tel: 17785675458,
    higher: "无",
    cjl: 0,
    cje: 0,
    dppf: "5.0",
    cps: 0,
    cpl: 0
  },
  {
    id: 1,
    name: "智联同城",
    rzTime: "2019-11-12",
    dqTime: "2019-12-23",
    status: 1,
    xyScore: 90,
    xyGrade: "良",
    bzMoney: 0,
    shopType: "家电",
    rate: 0.9,
    joinType: "来自青云同城的推荐/自入",
    shopGrade: "黄金商户",
    zye: 1090,
    kyye: 1090,
    zjye: 0,
    lxr: "派大星",
    tel: 17785675458,
    higher: "无",
    cjl: 0,
    cje: 0,
    dppf: "5.0",
    cps: 0,
    cpl: 0
  }
];

export const adminList = [
  {
    name: "商品管理",
    list: [
      "商品发布",
      "仓库中的商品",
      "出售中的商品",
      "库存日志",
      "商品规格",
      "品牌申请",
      "店铺信息",
      "淘宝导入"
    ]
  },
  {
    name: "订单物流",
    list: [
      "订单列表(订单管理)",
      "虚拟订单",
      "发货",
      "发货设置",
      "商品评论",
      "拼团列表",
      "拼团订单",
      "发货列表",
      "快递公司",
      "批量发货"
    ]
  }
];
